var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.998,
    viewBox: "0 0 16 15.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "paper-plane-solid",
    d: "M15.556.171a1,1,0,0,1,.422.975l-2,13a1,1,0,0,1-1.375.769L8.865,13.358,6.724,15.673a1,1,0,0,1-1.734-.681V12.38a.489.489,0,0,1,.131-.334l5.238-5.714a.5.5,0,0,0-.7-.709L3.3,11.268.543,9.887A1,1,0,0,1-.01,9.022a1.007,1.007,0,0,1,.5-.9l14-8a1,1,0,0,1,1.063.044Z",
    transform: "translate(0.01 0.004)",
    fill: "#1d1d26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/ChatSend.afe9b432b0d56f1428aa12abc731fa2b.svg";
export { ForwardRef as ReactComponent };